import { render } from "./InputToggle.vue?vue&type=template&id=491a487d"
import script from "./InputToggle.vue?vue&type=script&lang=js"
export * from "./InputToggle.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__